import { useQuery } from "@pinia/colada";
import { createError } from "#app";
import { watchEffect } from "vue";

import type { LocaleMorpheus } from "@solvari/translations";

import {
  useMunicipality,
  useProvince,
} from "~/features/company-wall/api/geo.api.ts";
import { useGeoProductCategory } from "~/features/company-wall/api/localSearch.api.ts";

function useLocalSearchData(params: {
  geoProductSlug: string;
  localeCode: LocaleMorpheus;
  municipality?: string;
  province: string;
}) {
  const { data: geoProductCategory } = useQuery(
    useGeoProductCategory({
      slug: params.geoProductSlug,
      localeCode: params.localeCode,
      hasLocalSearch: true,
    }),
  );

  const { data: province } = useQuery(
    useProvince({ slug: params.province, localeCode: params.localeCode }),
  );

  const { data: municipality } = useQuery({
    ...useMunicipality({
      slug: params.municipality!,
      localeCode: params.localeCode,
    }),
    enabled: () => !!params.municipality,
  });

  watchEffect(() => {
    if (
      province.value &&
      municipality.value &&
      province.value.id !== municipality.value.provinceId
    ) {
      throw createError({ statusCode: 404, statusMessage: "Page Not Found" });
    }
  });

  return { geoProductCategory, municipality, province };
}

export { useLocalSearchData };
